

if(window.innerWidth < 768){
  setTimeout(()=>{
  $(".box-Info.mobShow .readmoreDesc").click(function(){
          let mainParentDesc = $(this).closest(".new-widget-title")
          mainParentDesc.find(".box-Info .lessDesc").hide();
          mainParentDesc.find(".box-Info .allDescription").show();
          mainParentDesc.find('.box-Info.mobShow').addClass('active');
          mainParentDesc.find(".box-Info .readlessDesc")[0].focus();
        });
      
      $(".box-Info.mobShow .readlessDesc").click(function(){
        let mainParentDesc = $(this).closest(".new-widget-title")
        mainParentDesc.find(".box-Info .allDescription").hide();
        mainParentDesc.find(".box-Info .lessDesc").show();
        mainParentDesc.find('.box-Info.mobShow').removeClass('active');
        mainParentDesc.find(".box-Info .readmoreDesc")[0].focus();
        });
    },600)
    
}

